import WidgetWelcomePopup from './WidgetWelcomePopup';

export default WidgetWelcomePopup;
